import {classNames, React} from '@api'
import * as css from './NumberBadge.css'

export const NumberBadge : React.FC<{className?: string, active?: boolean, value?: number} & React.HTMLProps<HTMLSpanElement>> = React.forwardRef(({children, active, className, value, ...props}, ref) => {
  return <span className={classNames(css.root, className, active && css.active)} ref={ref} {...props} data-type='NumberBadge'>
    {value ?? (children || 0)}
  </span>
})


// WEBPACK FOOTER //
// ./src/shared/components/ui/components/NumberBadge.tsx